import { Fragment, memo } from 'react';
import EditData from './edit-data';
import Marriage from './marriage';
import CivilStatus from './civil-status';
import Widowhood from './widowhood';
import AccordionPerson from 'shell/components/shared/person';

const FormRegistrationWidowhoodComponent = (): React.ReactElement => {
  return (
    <Fragment>
      <AccordionPerson disabled />
      <EditData />
      <Marriage disabled />
      <CivilStatus disabled />
      <Widowhood />
    </Fragment>
  );
};

FormRegistrationWidowhoodComponent.displayName = 'Form Registration Widowhood component';

const FormRegistrationWidowhood = memo(FormRegistrationWidowhoodComponent);

export default FormRegistrationWidowhood;
